const moduleRoute = {
  path: '/solicitacoes-pendentes',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      // Página 100% React (strangler concluído) — tab na URL (?tab=...).
      path: '',
      component: () => import('./views/PendingRequestsReact.vue')
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
